import React, { useEffect, useState } from 'react'
import SaveAndEmailButton from '../elements/SaveAndEmailButton';
import { useLocation } from 'react-router-dom';


const SaveAndEmailFooter = () => {  
    let [show, setShow] = useState(true)
    let location = useLocation();

    useEffect(() => {
        if(location.pathname == "/final-price"){
            setShow(true)
        }else{
            setShow(false)
        }
    }, [location.pathname])
    
    if(!show) return null
    return (
        <div className="save-and-email d-lg-none">
            <SaveAndEmailButton />
        </div>
    )
}

export default SaveAndEmailFooter;